var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.201,
    height: 18.429,
    viewBox: "0 0 9.201 18.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11359",
    "data-name": "Path 11359",
    d: "M-1810.795-1921.264c0-.054.01-.107.01-.161q0-3.953,0-7.9v-.177h-2.663v-3.281h2.663c0-.087,0-.156,0-.226.008-.96-.017-1.922.033-2.88a3.915,3.915,0,0,1,1.349-2.92,3.761,3.761,0,0,1,2.458-.88c.862-.008,1.726.064,2.588.1a.613.613,0,0,1,.109.026v2.921h-.212c-.63.01-1.261-.008-1.888.038a1.065,1.065,0,0,0-1.11,1.081c-.053.9-.013,1.809-.013,2.733h2.951l-.408,3.277h-2.557c0,.072-.012.129-.012.186q0,3.952,0,7.9c0,.053.01.106.015.16Z",
    transform: "translate(1813.448 1939.693)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.c6bb4bcb156dd3374af9c267ccec3ffb.svg";
export { ForwardRef as ReactComponent };